export default {
  data() {
    return {
      disabledAutoScrolling: false // It's to prevent auto scrolling after claim the activity
    }
  },
  methods: {
    async onScrollingDownToSelectedActivity() {
      if (this.disabledAutoScrolling) return
      await new Promise(resolve => {
        setTimeout(() => {
          resolve()
        }, 300)
      })
      const activityId = this.$route.query.activity_id
      if (!activityId) return
      const id = `activity-card-${activityId}`
      const el = document.getElementById(id)
      if (!el) return

      const offset = 150 // adjust this value as needed (e.g., header height)
      const y = el.getBoundingClientRect().top + window.scrollY - offset

      window.scrollTo({
        top: y,
        behavior: 'smooth'
      })
      this.disabledAutoScrolling = true
    }
  }
}
